import type { WithdrawOrderDto } from '@/queries/withdraw/withdraw.schema';
import { useTranslations } from 'next-intl';
import Toast from '@/components/ui/Toast/toast';
import { useSocketEvent } from '@/hooks/socket/useSocketEvent';
import { useAppSelector } from '@/redux/hooks';

export interface WithdrawOrderReviewStatusUpdateMessage {
  orderId: string;
  userId: string;
  state: WithdrawOrderDto['state'] | string;
  result: 'approved' | 'rejected';
  reviewedBy: string;
  reviewedAt: string;
  reason?: string;
}

export function useWithdrawSocket() {
  const userSession = useAppSelector(state => state.user.userSession);
  const t = useTranslations('withdraw');

  useSocketEvent<WithdrawOrderReviewStatusUpdateMessage>(
    'withdraw-order.review.status.update',
    (data) => {
      if (data.result === 'approved') {
        Toast({
          type: 'success',
          title: t('manual-withdrawal-approved.title'),
          description: t('manual-withdrawal-approved.description'),
        });
        return;
      }

      if (data.result === 'rejected') {
        Toast({
          type: 'error',
          title: t('manual-withdrawal-rejected.title'),
          disableTimer: true,
          description: t('manual-withdrawal-rejected.description'),
          acceptButtonText: t('manual-withdrawal-rejected.support-button'),
          onAccept: () => {
            window.Intercom?.('show');
          },
        });
      }
    },
    Boolean(userSession),
  );
}
